export default __webpack_public_path__ + "static/media/icon_app-store.7e070645-2.f83ac72b.svg";